import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { RetroGrid } from '../components/effects';
import {
  Hero,
  About,
  WhatIDo,
  Portfolio,
  Experience,
  Playground,
  Contact,
} from '../components/sections';

/**
 * HomePage - Página principal del sitio
 *
 * Compone todas las secciones de la landing page con estilo Retrowave/Synthwave.
 */
export function HomePage() {
  return (
    <>
      {/* Animated Retrowave Background */}
      <RetroGrid />

      {/* Header Navigation */}
      <Header />

      {/* Main Content */}
      <main>
        <Hero />
        <About />
        <WhatIDo />
        <Portfolio />
        <Experience />
        <Playground />
        <Contact />
      </main>

      {/* Footer */}
      <Footer />
    </>
  );
}
